import React, { useState } from 'react';
import { Id } from '../../../../convex/_generated/dataModel';
import { Dialog, DialogBody, DialogTitle } from '../../../../catalyst-components/dialog';
import { Field, Label } from '../../../../catalyst-components/fieldset';
import { Select } from '../../../../catalyst-components/select';
import { Button } from '../../../../catalyst-components/button';
import { Assistant } from '../../../../shared/models';

interface AssistantDialogProps {
  open: boolean;
  onClose: () => void;
  onSubmit: (data: {
    assistantId: Id<"assistants">;
  }) => Promise<void>;
  assistants: Assistant[];
}

export const AssistantDialog: React.FC<AssistantDialogProps> = ({
  open,
  onClose,
  onSubmit,
  assistants,
}) => { 
  const [selectedAssistantId, setSelectedAssistantId] = useState<Id<"assistants"> | null>(null);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!selectedAssistantId) return;

    await onSubmit({
      assistantId: selectedAssistantId,
    });

    // Reset form
    setSelectedAssistantId(null);
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogBody>
        <DialogTitle>Add New Phase Assistant</DialogTitle>
        <form onSubmit={handleSubmit} className="space-y-4">
          <Field>
            <Label>Assistant</Label>
            <Select
              required
              value={selectedAssistantId || ''}
              onChange={(e) => setSelectedAssistantId(e.target.value as Id<"assistants">)}
            >
              <option value="">Select an assistant...</option>
              {assistants.map(assistant => (
                <option key={assistant._id} value={assistant._id}>
                  [{assistant.typeName}] - {assistant.name}
                </option>
              ))}
            </Select>
          </Field>

          <div className="flex justify-end gap-2 mt-4">
            <Button color="light" onClick={onClose}>
              Cancel
            </Button>
            <Button color="light" type="submit">
              Add Assistant
            </Button>
          </div>
        </form>
      </DialogBody>
    </Dialog>
  );
};
